import type { ContextModalProps } from "@mantine/modals"
import { ActivityInfo } from "./activities"
import { ModalPeerDetails } from "./surveys/details/ModalPeerDetails"
import { ModalUserSessionDetails } from "./surveys/details/ModalUserSessionDetails"

export const modalsRegistry = {
  ActivityInfo: ({ innerProps, ...rest }) => <ActivityInfo {...innerProps} {...(rest as ContextModalProps)} />,
  UserSessionDetails: ({ innerProps, ...rest }) => (
    <ModalUserSessionDetails {...innerProps} {...(rest as ContextModalProps)} />
  ),
  PeerSessionDetails: ({ innerProps, ...rest }) => (
    <ModalPeerDetails {...innerProps} {...(rest as ContextModalProps)} />
  ),
}

declare module "@mantine/modals" {
  export interface MantineModalsOverride {
    modals: typeof modalsRegistry
  }
}
